import { render, staticRenderFns } from "./inviteRecord.vue?vue&type=template&id=475737d5&"
import script from "./inviteRecord.vue?vue&type=script&lang=js&"
export * from "./inviteRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports